import cn from '@/lib/cn';

export default function Container({
  children,
  className = undefined,
  id = undefined,
  tag = 'div',
}: PropsWithRequiredChildren<{
  className?: string;
  id?: string;
  tag?: 'article' | 'div' | 'section';
}>) {
  const Tag = tag;

  return (
    <Tag
      id={id}
      className={cn(
        'mx-auto w-full max-w-[105rem] px-5 sm:px-24 md:px-16',
        className,
      )}
    >
      {children}
    </Tag>
  );
}
